const resolveDraftStatusUpdatedAt = ({
    collabDocUpdatedAt,
    latestScopeUpdateEventUpdatedAt,
    engagementUpdatedAt,
    localSaveUpdatedAt,
}: {
    collabDocUpdatedAt?: number | null,
    latestScopeUpdateEventUpdatedAt?: number | null,
    engagementUpdatedAt?: number | null,
    localSaveUpdatedAt?: number | null,
}): number | null => {
    const nextTimestamp = Math.max(
        collabDocUpdatedAt ?? 0,
        latestScopeUpdateEventUpdatedAt ?? 0,
        engagementUpdatedAt ?? 0,
        localSaveUpdatedAt ?? 0,
    );

    return nextTimestamp > 0 ? nextTimestamp : null;
};

export default resolveDraftStatusUpdatedAt;
